// import React from "react";

// const PrivacyPolicy = () => {
//   return (
//     <div className="min-h-screen bg-[#f4f7fc] px-4 py-10">
//       <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
//         <div className="bg-gradient-to-r from-slate-900 to-slate-700 px-8 py-10">
//           <h1 className="text-3xl md:text-4xl font-semibold text-white">
//             Privacy Policy
//           </h1>

//           <p className="mt-4 max-w-3xl text-sm leading-7 text-slate-200">
//             This Privacy Policy explains how Replex Engine collects, uses,
//             stores, shares, protects, and handles information when you use our
//             services, including Google and Microsoft integrations.
//           </p>

//           <p className="mt-4 text-sm font-medium text-slate-300">
//             Last Updated: June 23, 2026
//           </p>
//         </div>

//         <div className="p-8 md:p-10">
//           <div className="space-y-8 text-sm leading-7 text-slate-600">
//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 1. Information We Collect
//               </h2>
//               <p>
//                 We may collect your name, email address, profile information,
//                 organization details, contact information, authentication data,
//                 account identifiers, usage data, device information, logs,
//                 workflow settings, connected account information, and other
//                 information required to provide and secure our services.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 2. How We Use Your Information
//               </h2>
//               <p>
//                 We use your information to provide Replex Engine services,
//                 authenticate users, manage accounts, enable integrations,
//                 process requested actions, automate lead workflows, improve
//                 platform performance, provide support, prevent abuse,
//                 troubleshoot issues, and comply with legal obligations.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 3. Google User Data
//               </h2>

//               <p>
//                 If you connect your Google account, Replex Engine may access the
//                 Google user data that you authorize during the OAuth consent
//                 process. Depending on the features you choose to use, this may
//                 include your Google account email address, basic profile
//                 information, Gmail messages, Gmail send permissions, Gmail labels
//                 or metadata, and Google Calendar event data.
//               </p>

//               <p className="mt-3">
//                 We use Google user data only to provide Replex Engine’s
//                 user-facing functionality. Gmail data may be used to detect
//                 inbound leads, understand message intent, generate or send email
//                 replies, organize lead workflows, and run follow-up automation.
//                 Calendar data may be used only if a calendar-related feature is
//                 enabled by the user.
//               </p>

//               <p className="mt-3">
//                 We do not sell Google user data. We do not use Google user data
//                 for advertising. We do not use Google user data to train general
//                 AI models. We do not transfer Google user data to third parties
//                 except as necessary to provide or improve Replex Engine’s
//                 functionality, comply with law, prevent abuse, or protect our
//                 users and services.
//               </p>

//               <p className="mt-3">
//                 Replex Engine’s use and transfer of information received from
//                 Google APIs will adhere to the Google API Services User Data
//                 Policy, including the Limited Use requirements.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 4. Microsoft User Data
//               </h2>
//               <p>
//                 If you connect your Microsoft account, Replex Engine accesses
//                 only the Microsoft data and permissions you approve during the
//                 consent process. This may include basic profile information,
//                 email address, Microsoft account identifiers, Outlook data,
//                 calendar data, or Microsoft Graph data depending on the features
//                 you choose to use.
//               </p>
//               <p className="mt-3">
//                 Microsoft user data is used only to provide the requested Replex
//                 Engine functionality. We do not sell Microsoft user data, use it
//                 for advertising, or share it with unauthorized third parties.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 5. Third-Party Services
//               </h2>
//               <p>
//                 Replex Engine may use third-party services such as Google,
//                 Microsoft, hosting providers, analytics providers, email
//                 providers, payment processors, AI infrastructure providers, and
//                 other infrastructure services. These providers may process data
//                 only as necessary to support our platform and services.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 6. Data Sharing
//               </h2>
//               <p>
//                 We do not sell your personal information. We may share
//                 information only with service providers that help us operate the
//                 platform, when required by law, to protect rights and security,
//                 prevent abuse, or with your consent.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 7. Data Security
//               </h2>
//               <p>
//                 We use reasonable technical and organizational safeguards to
//                 protect your information from unauthorized access, misuse,
//                 disclosure, alteration, or destruction. These safeguards may
//                 include encrypted transmission, access controls, secure
//                 infrastructure, monitoring, and restricted internal access.
//                 However, no method of transmission or storage is completely
//                 secure.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 8. Google Data Storage and Protection
//               </h2>
//               <p>
//                 Replex Engine stores only the data necessary to provide the
//                 requested automation features, maintain user workflows,
//                 authenticate connected accounts, and keep the service secure.
//                 Where applicable, access tokens, refresh tokens, workflow
//                 settings, email metadata, lead status, and related automation
//                 records may be stored securely.
//               </p>

//               <p className="mt-3">
//                 Access to Google user data is limited to authorized systems or
//                 personnel only when required to operate, secure, or support the
//                 service.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 9. Data Retention
//               </h2>
//               <p>
//                 We retain information only as long as necessary to provide our
//                 services, comply with legal obligations, resolve disputes,
//                 prevent abuse, and enforce our agreements. When information is
//                 no longer needed, we delete or anonymize it where appropriate.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 10. User Control, Revocation, and Deletion
//               </h2>
//               <p>
//                 You may revoke Replex Engine’s access to your Google or
//                 Microsoft account at any time from your account security or
//                 connected apps settings.
//               </p>

//               <p className="mt-3">
//                 You may request deletion of your personal data, connected
//                 account data, stored automation records, and Google user data by
//                 contacting us at paul@replexengine.com. After receiving a
//                 verified deletion request, we will delete or anonymize applicable
//                 data unless retention is required for legal, security, fraud
//                 prevention, or compliance reasons.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 11. Children’s Privacy
//               </h2>
//               <p>
//                 Replex Engine is not intended for children under 13. We do not
//                 knowingly collect personal information from children under 13.
//               </p>
//             </section>

//             <section>
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 12. Changes to This Policy
//               </h2>
//               <p>
//                 We may update this Privacy Policy from time to time. Any changes
//                 will be posted on this page with an updated “Last Updated” date.
//                 If we materially change how we use Google user data, we will
//                 provide notice where required.
//               </p>
//             </section>

//             <section className="rounded-xl border border-slate-200 bg-slate-50 p-5">
//               <h2 className="text-lg font-semibold text-slate-900 mb-2">
//                 Contact Us
//               </h2>
//               <p>
//                 Support Email:{" "}
//                 <a
//                   href="mailto:paul@replexengine.com"
//                   className="font-medium text-indigo-600 hover:underline"
//                 >
//                   paul@replexengine.com
//                 </a>
//               </p>
//               <p>
//                 Website:{" "}
//                 <a
//                   href="https://replexengine.com"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="font-medium text-indigo-600 hover:underline"
//                 >
//                   https://replexengine.com
//                 </a>
//               </p>
//             </section>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PrivacyPolicy;


import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#f4f7fc] px-4 py-10">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        
        <div className="bg-gradient-to-r from-slate-900 to-slate-700 px-8 py-10">
          <h1 className="text-3xl md:text-4xl font-semibold text-white">
            Privacy Policy
          </h1>

          <p className="mt-4 max-w-3xl text-sm leading-7 text-slate-200">
            This Privacy Policy explains how Replex Engine collects, uses,
            stores, and protects information when you use our services,
            including Google and Microsoft integrations.
          </p>

          <p className="mt-4 text-sm font-medium text-slate-300">
            Last Updated: June 23, 2026
          </p>
        </div>

        <div className="p-8 md:p-10">
          <div className="space-y-8 text-sm leading-7 text-slate-600">

            {/* 1 */}
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                1. Information We Collect
              </h2>
              <p>
                We may collect your name, email address, profile information,
                authentication data, account identifiers, usage data, device
                information, logs, and connected account information necessary
                to provide our services.
              </p>
            </section>

            {/* 2 */}
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                2. How We Use Your Information
              </h2>
              <p>
                We use your information to provide and operate Replex Engine,
                authenticate users, manage accounts, enable integrations, and
                process user-requested actions such as reading and sending emails.
              </p>
            </section>

            {/* 3 */}
           <section>
  <h2 className="text-lg font-semibold text-slate-900 mb-2">
    3. Google User Data
  </h2>

  <p>
    When you connect your Google account, Replex Engine accesses only the
    Google data that you explicitly authorize through the OAuth consent
    process. This may include your Google account email address, basic profile
    information, and Gmail data required to provide email automation and
    conversation management features.
  </p>

  <p className="mt-3">
    Replex Engine uses Gmail API access to send automated emails on your behalf
    through your connected Gmail account. This includes sending initial emails,
    scheduled follow-ups, and other messages based on workflows and templates
    created by you.
  </p>

  <p className="mt-3">
    Replex Engine may access email threads and responses related to automated
    email campaigns to identify replies, maintain conversation context, and
    display email conversations within the platform. This allows users to view
    and respond to conversations directly from Replex Engine.
  </p>

  <p className="mt-3">
    We only access Gmail data necessary to provide the requested email
    automation features. We do not access unrelated Gmail content, and we do
    not automatically modify, organize, or delete Gmail messages.
  </p>

  <p className="mt-3">
    We do not sell Google user data, use Google user data for advertising, or
    use Google user data to train general AI models. Google user data is only
    used to provide the features requested by the user.
  </p>

  <p className="mt-3">
    Users can revoke Replex Engine's access to their Google account at any time
    through their Google Account settings or by disconnecting their account
    from Replex Engine.
  </p>

  <p className="mt-3">
    Replex Engine complies with the Google API Services User Data Policy,
    including Limited Use requirements.
  </p>
</section>
            {/* 4 */}
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                4. Microsoft User Data
              </h2>
              <p>
                If you connect your Microsoft account, we access only the data
                you authorize such as email and profile information, used solely
                to provide requested features.
              </p>
            </section>

            {/* 5 */}
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                5. Data Sharing
              </h2>
              <p>
                We do not sell personal data. We only share data with service
                providers necessary to operate the platform or when required by law.
              </p>
            </section>

            {/* 6 */}
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                6. Data Security
              </h2>
              <p>
                We use reasonable security measures including encryption and
                access controls. However, no system is fully secure.
              </p>
            </section>

            {/* 7 */}
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                7. Data Retention
              </h2>
              <p>
                We retain data only as long as necessary to provide services,
                comply with legal obligations, and prevent abuse.
              </p>
            </section>

            {/* 8 */}
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                8. User Control
              </h2>
              <p>
                You can disconnect your Google or Microsoft account anytime and
                request deletion of your data by contacting support.
              </p>
            </section>

            {/* 9 */}
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                9. Children’s Privacy
              </h2>
              <p>
                We do not knowingly collect data from children under 13.
              </p>
            </section>

            {/* 10 */}
            <section>
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                10. Changes to This Policy
              </h2>
              <p>
                We may update this policy from time to time. Changes will be
                posted on this page.
              </p>
            </section>

            {/* Contact */}
            <section className="rounded-xl border border-slate-200 bg-slate-50 p-5">
              <h2 className="text-lg font-semibold text-slate-900 mb-2">
                Contact Us
              </h2>

              <p>
                Support Email:{" "}
                <a
                  href="mailto:paul@replexengine.com"
                  className="font-medium text-indigo-600 hover:underline"
                >
                  paul@replexengine.com
                </a>
              </p>

              <p>
                Website:{" "}
                <a
                  href="https://replexengine.com"
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-indigo-600 hover:underline"
                >
                  https://replexengine.com
                </a>
              </p>
            </section>

          </div>
        </div>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
